import { inspectionClient } from '@/config/api';

// Types
export interface DashboardFilters {
  searchCode?: string;
  startDate?: string;
  endDate?: string;
  status?: string;
  subStatus?: string;
  providerId?: string;
  inspectorId?: string;
}

export interface CountByDate {
  label: string;
  count: number;
  isOld: boolean;
}

export interface SubItem {
  label: string;
  count: number;
}

export interface DashboardCard {
  id: string;
  title: string;
  icon: string;
  total: number;
  color: string;
  countsByDate: CountByDate[];
  subItems?: SubItem[];
}

export interface PendingItem {
  id: string;
  inspectionItemId: string;
  code: string;
  type: string;
  description: string;
  daysOverdue: number;
  priority: 'high' | 'medium' | 'low';
}

export interface DashboardStats {
  cards: DashboardCard[];
  pendingItems: PendingItem[];
  totalInspections: number;
  lastUpdated: string;
}

export interface DashboardSummary {
  totalInspections: number;
  awaitingDirection: number;
  inProgress: number;
  awaitingReview: number;
  pendingIssues: number;
  lastUpdated: string;
}

export class DashboardService {
  /**
   * Get full dashboard statistics with filters
   */
  async getStats(filters?: DashboardFilters): Promise<DashboardStats> {
    const params = new URLSearchParams();

    if (filters?.searchCode) {
      params.append('searchCode', filters.searchCode);
    }
    if (filters?.startDate) {
      params.append('startDate', filters.startDate);
    }
    if (filters?.endDate) {
      params.append('endDate', filters.endDate);
    }
    if (filters?.status) {
      params.append('status', filters.status);
    }
    if (filters?.subStatus) {
      params.append('subStatus', filters.subStatus);
    }
    if (filters?.providerId) {
      params.append('providerId', filters.providerId);
    }
    if (filters?.inspectorId) {
      params.append('inspectorId', filters.inspectorId);
    }

    const queryString = params.toString();
    const url = queryString ? `/api/Dashboard/stats?${queryString}` : '/api/Dashboard/stats';

    const response = await inspectionClient.get<DashboardStats>(url);
    return response.data;
  }

  /**
   * Get quick summary for dashboard header
   */
  async getSummary(): Promise<DashboardSummary> {
    const response = await inspectionClient.get<DashboardSummary>('/api/Dashboard/summary');
    return response.data;
  }
}

export const dashboardService = new DashboardService();
